import styled from 'styled-components';

const StyledWrapper = styled.div `
  @media screen and (max-width: ${props => props.theme.breakpoints.xl}) {
    position: relative;

    &:before,
    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 1rem;
      background: ${props => props.theme.gradients.horizontalList.prevOverlay};
    }

    &:after {
      right: 0;
      left: auto;
      background: ${props => props.theme.gradients.horizontalList.nextOverlay};
    }
  }
`;
const StyledContainer = styled.div `
  @media screen and (max-width: ${props => props.theme.breakpoints.xl}) {
    padding: 15px 1rem;
    text-align: center;
    overflow: auto;

    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;
const StyledList = styled.ul `
  display: inline-flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  gap: 20px;
  padding: 0;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    gap: 2rem;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.xl}) {
    margin: 0;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) and (max-width: ${props => props.theme.breakpoints.xxl}) {
    gap: 1rem;
  }

  font-weight: ${props => props.theme.typography.fontWeight.medium};
`;
const StyledListItem = styled.li `
  all: unset;
  cursor: pointer;
`;

export { StyledContainer, StyledList, StyledListItem, StyledWrapper };
//# sourceMappingURL=Horizontal.styles.mjs.map
